import { SelectOption } from "components/common/FormDialog/types";
import { isObject } from "./isObject";
import { isString } from "./isString";

export const isSelectOption = (x: unknown): x is SelectOption =>
  isObject(x) && isString(x["label"]) && isString(x["value"]);
